import { c as _c } from "react/compiler-runtime";
import { Card } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import type { VaultType } from '@/entities/hooks/use-entity-vault';
import { CardError, CardSkeleton } from '../../../card-title';
type EncryptedContentProps = {
  canDecrypt: boolean;
  vaultData: VaultType | undefined;
  /** Why the onboarding's data didn't load, which leaves no vault to read. */
  error?: unknown;
};
const EncryptedContent = t0 => {
  const $ = _c(8);
  const {
    canDecrypt,
    vaultData,
    error
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings.businessShared.encrypted"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  if (!vaultData) {
    let t2;
    if ($[1] !== error) {
      t2 = <div className="p-5">{error ? <CardError error={error} /> : <CardSkeleton rows={1} />}</div>;
      $[1] = error;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  let t2;
  if ($[3] !== canDecrypt || $[4] !== t) {
    t2 = canDecrypt ? t(_temp) : t(_temp2);
    $[3] = canDecrypt;
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <div className="p-5"><Card.Root><Card.Empty>{t2}</Card.Empty></Card.Root></div>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default EncryptedContent;
function _temp($) {
  return $.description;
}
function _temp2($_0) {
  return $_0.notAllowed;
}